<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Case of the Sliding Pool</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="toch"><b>Contents</b></p>
<p class="toc"><a href="#/xhtml/chapter01">1: THE SLIDING POOL</a></p>
<p class="toc"><a href="#/xhtml/chapter02">2: JOHN DOE</a></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">3: MURDER MOST FOUL</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">4: NAGA ORASHI</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">5: FRED LUNDMAN</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">6: ROSITA</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">7: DR. LEO HARTMAN</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">8: THE MIDTOWN MANHATTAN NATIONAL BANK</span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample">9: BLIND ALLEYS</span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10: THE POLICE ARTIST</span></p>
<p class="toc"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11: ISHIDO</span></p>
<p class="toc"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12: THE BOMB</span></p>
<p class="toc"><span href="#/xhtml/chapter13" title="Link target outside of Sample">13: ERIC SAUNDERS</span></p>
<p class="toc"><span href="#/xhtml/chapter14" title="Link target outside of Sample">14: THE GAME PLAYERS</span></p>
<p class="toc"><span href="#/xhtml/chapter15" title="Link target outside of Sample">15: SAMURAI</span></p>
<p class="toc"><span href="#/xhtml/teaser00" title="Link target outside of Sample">Preview: <i>The Case of the Kidnapped Angel</i></span></p>
<p class="toc"><span href="#/xhtml/biography" id="bio" title="Link target outside of Sample">A Biography of Howard Fast</span></p>
<p class="toc"><span href="#/xhtml/copyright" id="copy" title="Link target outside of Sample">Copyright Page</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8ad2bbdc